import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1;

const PropertyIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 30;

	if (size) {
		height = size;
	}
	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M29.4961 13.4111L26.9618 11.1019V3.4447C26.9618 2.95749 26.5668 2.56245 26.0795 2.56245H19.9791C19.4918 2.56245 19.0968 2.95743 19.0968 3.4447V3.93536L16.0361 1.14647C15.4453 0.608057 14.5544 0.608115 13.9638 1.14642L0.50378 13.4112C0.030577 13.8425 -0.12581 14.5069 0.105401 15.1039C0.336671 15.7009 0.899757 16.0867 1.54001 16.0867H3.68976V28.375C3.68976 28.8622 4.08474 29.2572 4.572 29.2572H11.9497C12.4369 29.2572 12.832 28.8623 12.832 28.375V20.9139H17.168V28.375C17.168 28.8623 17.5629 29.2573 18.0502 29.2573H25.4276C25.9148 29.2573 26.3099 28.8623 26.3098 28.375V16.0867H28.46C29.1002 16.0867 29.6634 15.7009 29.8946 15.104C30.1258 14.5069 29.9695 13.8425 29.4961 13.4111ZM25.4276 14.3222C24.9404 14.3222 24.5454 14.7172 24.5454 15.2045V27.4928H18.9325V20.0317C18.9325 19.5444 18.5375 19.1494 18.0503 19.1494H11.9497C11.4625 19.1494 11.0675 19.5444 11.0675 20.0317V27.4928H5.45419V15.2045C5.45419 14.7173 5.05921 14.3222 4.57194 14.3222H2.12372L15 2.5894L19.385 6.58497C19.6433 6.82028 20.0161 6.88093 20.3356 6.73989C20.6552 6.59868 20.8614 6.28216 20.8614 5.93282V4.32694H25.1974V11.4916C25.1974 11.7398 25.3019 11.9765 25.4855 12.1437L27.8763 14.3222H25.4276Z"
				fill={color}
			/>
		</svg>
	);
};

export default PropertyIcon;
